import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { FlatList } from 'react-native';

import { LoadingTable } from '../LoadingTable';

import { tabletWidthCols, tableHead } from './constants';

import { PlatformQueryContainerDataProps } from '.';

interface ProductItemProps {
  item: PlatformQueryContainerDataProps['data'][0];
}

export const ProductItemValueTablet: React.FC<{ value: string; label: string; width: number }> = ({
  value,
  label,
  width,
}) => {
  return (
    <VStack
      w={`${width}%`}
      space={Spacing['stack.nano']}
      px={Spacing['inline.nano']}
      justifyContent="space-between">
      <UI.Text variant="semibold">{label}</UI.Text>
      <UI.Text>{value}</UI.Text>
    </VStack>
  );
};

export const ProductItemTablet: React.FC<ProductItemProps> = ({ item }) => {
  return (
    <UI.Shadow
      level={1}
      p={Spacing['inset.xs']}
      my={Spacing['stack.nano']}
      borderRadius={BoxBorder.heavy}>
      <HStack justifyContent="space-between">
        <ProductItemValueTablet
          label={tableHead.platform}
          value={item.toolName}
          width={tabletWidthCols.platform}
        />
        <ProductItemValueTablet
          label={tableHead.package}
          value={item.packageName}
          width={tabletWidthCols.package}
        />
        <ProductItemValueTablet
          label={tableHead.initialDate}
          value={Utils.Mask.DateFormat(item.hiringDate, 'dd/MM/yyyy - HH:mm:ss')}
          width={tabletWidthCols.initialDate}
        />
        <ProductItemValueTablet
          label={tableHead.finalDate}
          value={
            item.cancelDate ? Utils.Mask.DateFormat(item.cancelDate, 'dd/MM/yyyy - HH:mm:ss') : '--'
          }
          width={tabletWidthCols.finalDate}
        />
        <ProductItemValueTablet
          label={tableHead.adhesionStatus}
          value={item.hiringStateDescription}
          width={tabletWidthCols.adhesionStatus}
        />
      </HStack>
    </UI.Shadow>
  );
};

export const ContentTablet: React.FC<PlatformQueryContainerDataProps> = ({ isLoading, data }) => {
  return (
    <VStack my={Spacing['inset.sm']} paddingY={Spacing['inline.xxs']}>
      {isLoading ? (
        <LoadingTable columns={5} />
      ) : (
        <FlatList
          windowSize={20}
          maxToRenderPerBatch={20}
          updateCellsBatchingPeriod={5}
          data={data}
          // ListEmptyComponent={<LoadingTable columns={columns} />}
          showsVerticalScrollIndicator={false}
          // onEndReached={handleEndReached}
          onEndReachedThreshold={1.5}
          // ListFooterComponent={loadingFooter}
          renderItem={({ item }) => <ProductItemTablet item={item} />}
        />
      )}
    </VStack>
  );
};
